import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import ReportRepository from '../Repositories/ReportRepository'


class ReportBloc {

    detailChannel = new Subject();
    reportChannel = new Subject();
    reportSendChannel = new Subject();
    repository = new ReportRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.reportChannel.next({status: apiResponse.INITIAL})
        this.reportSendChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
    
    fetchReport = async (query) => {
        try {
            this.reportChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchReport(query).then((result) => {
                this.reportChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.reportChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchReportSend = async (query) => {
        try {
            this.reportSendChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchReportSend(query).then((result) => {
                this.reportSendChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.reportSendChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }
}

export default ReportBloc